export default {
  common: {
    brand: 'USFans Spreadsheet',
    tagline: 'Centre de ressources indépendant',
    navHome: 'Accueil',
    navShoppingGuide: "Guide d'achat",
    navGuides: 'Guides',
    navCategories: 'Catégories',
    navResources: 'Ressources',
    navReview: 'Avis',
    navFaq: 'FAQ',
    visitMain: 'Visiter le site principal',
    language: 'Langue',
    mainSiteUrl: 'https://kaspreadsheet.com',
    footerAbout: 'USFans Spreadsheet est une ressource indépendante qui organise les articles et vêtements de fans américains dans une structure simple et facile à parcourir, afin que vous trouviez ce que vous cherchez plus vite.',
    footerQuickLinks: 'Liens rapides',
    footerCategories: 'Catégories',
    footerDisclaimer: 'Ce site est une ressource informative indépendante et n\'est affilié officiellement à aucune marque, sauf mention explicite. Tous les liens produits mènent au site principal.',
    footerRights: 'Tous droits réservés.',
    notFoundTitle: 'Cette page est introuvable',
    notFoundText: "La page que vous cherchez n'existe pas. Revenez pour explorer le centre de ressources.",
  },
  cat: {
    shoes: 'Chaussures',
    hoodies: 'Sweats/Hoodies',
    tshirts: 'T-shirts',
    jackets: 'Vestes',
    pants: 'Pantalons/Shorts',
    headwear: 'Couvre-chefs',
    sets: 'Ensembles',
    underwear: 'Sous-vêtements/Caleçons',
    jersey: 'Maillot',
    accessories: 'Accessoires',
    bags: 'Sacs',
    belts: 'Ceintures',
    perfumes: 'Parfums',
    other: 'Autres',
  },
};